module.exports = __webpack_public_path__ + "img/dog-outline-partial.c441283d.png";